import { PLL_LINKS } from '../Config/config'
import { CURRENT_YEAR } from '../Config/League/league.config'
import { TICKETMASTER_BASE_URL, TICKETMASTER_CAME_FROM } from '../Constants/tickets'

export const TEAMS_URL = '/teams'
export const PLAYER_URL = '/player'
export const SCHEDULE_URL = '/schedule'
export const SCORES_URL = '/scores'
export const TICKETS_URL = '/tickets'
export const MATCHUP_URL = '/matchup'
export const EVENT_HUB_URL = '/event-hub'
export const STANDINGS_URL = '/standings'
export const PREDICTIONS_URL = '/predictions'
export const INJURY_REPORT_URL = '/injury-report'
export const TRANSACTIONS_URL = '/transactions'
export const CONTRACTS_URL = '/contracts'
export const LEAGUE_CONTRACTS_URL = '/league-contracts'
export const BETTING_URL = '/bet'
export const DRAFT_URL = '/draft'
export const DRAFT_CENTRAL_URL = '/draft-central'
export const ALL_STAR_VOTING_URL = '/all-star-vote'
export const ALL_STAR_URL = '/all-star'
export const PLAYOFFS_URL = '/playoffs'
export const QUESTIONS_URL = '/questions'
export const SINGLE_VIDEO_URL = '/videos'
export const VIDEOS_BY_TAG_URL = '/videos/tag'
export const SINGLE_GAME_HIGHLIGHTS_URL = '/videos/highlights'
export const INTERNATIONAL_WATCH_URL = '/watch/international'
export const INTERNATIONAL_WATCH_CONFIRM_URL = '/watch/international?success=true'
export const PLAYER_MOVEMENT_URL = '/player-movement'
export const FREE_AGENCY_URL = '/free-agency'
export const FREE_AGENCY_TRACKER_URL = '/free-agency-tracker'
export const ACADEMY_URL = '/academy'
export const ACADEMY_EVENTS_URL = '/academy/schedule'
export const ACADEMY_BOYS_URL = '/academy/boys'
export const ACADEMY_GIRLS_URL = '/academy/girls'
export const ACADEMY_VERIFIED_URL = '/academy/verified'
export const PLAY_URL = '/play'
export const PLAY_BOYS_URL = '/play/boys'
export const PLAY_GIRLS_URL = '/play/girls'
export const PLAY_EVENTS_URL = '/play/schedule'
export const PLAY_VERIFIED_URL = '/play/academy/pll-verified'
export const PLL_NATION_SHOP_URL = '/pll-nation/shop'
export const FANTASY_GROUPS_URL = '/fantasy/groups'
export const HELMET_HUNT_URL = '/helmet-hunt-week'
export const CHAMPIONSHIP_SERIES = '/championship-series'
export const CHAMPIONSHIP_SERIES_SCHEDULE = '/championship-series/schedule'

export type RouteNames =
  | 'teams'
  | 'roster'
  | 'homepage'
  | 'player'
  | 'schedule'
  | 'scores'
  | 'tickets'
  | 'login'
  | 'matchups'
  | 'event-hub'
  | 'standings'
  | 'predictions'
  | 'injury-report'
  | 'transactions'
  | 'league-contracts'
  | 'bet'
  | 'draft-central'
  | 'all-star'
  | 'playoffs'
  | 'questions'
export type PlayerTabs = 'profile' | 'stats' | 'media'
export type SeasonType = 'regular' | 'post' | 'allstar' | 'champseries'

export type UrlParams = {
  id?: string
  tab?: PlayerTabs
  firstName?: string
  lastName?: string
  year?: number
  seasonType?: SeasonType
  slugName?: string
}

/**
 * Create URL for all routes
 */
export function createUrl(name: RouteNames, params: UrlParams = {}): string {
  const required = (param: keyof UrlParams) => {
    if (params[param] === undefined) {
      if (process.env['NODE_ENV'] === 'development') {
        throw new Error(`missing required param ${param} in createUrl`)
      }
    }
  }

  if (name === 'teams') {
    required('id')
    return `${TEAMS_URL}/${params.id}`
  }

  if (name === 'roster') {
    required('id')
    return `${TEAMS_URL}/${params.id}/roster`
  }

  if (name === 'player') {
    let slug
    if (params.slugName) {
      slug = params.slugName
    } else {
      slug = `${params.firstName?.toLowerCase()}-${params.lastName?.toLowerCase()}`
    }

    let url: string
    if (params.tab && params.tab === 'profile') {
      url = `${PLAYER_URL}/${slug}`
    } else {
      url = `${PLAYER_URL}/${slug}/${params.tab}`
    }
    const data: { [key: string]: string } = {}
    if (params.year && params.year !== CURRENT_YEAR) {
      data.year = params.year.toString()
    }
    if (params.seasonType && params.seasonType !== 'regular') {
      data.type = params.seasonType
    }
    let stringifiedData = Object.keys(data)
      .map((key) => `${key}=${data[key]}`)
      .join('&')
    return `${url}${Object.keys(data).length !== 0 ? `?${stringifiedData}` : ''}`
  }

  if (name === 'schedule') {
    return '/ss'
  }
  if (name === 'scores') {
    return '/scores'
  }
  if (name === 'tickets') {
    return '/tickets'
  }

  if (name === 'matchups') {
    return '/matchups'
  }

  if (name === 'login') {
    return `/login`
  }

  if (name === 'event-hub') {
    return `/event-hub`
  }

  if (name === 'standings') {
    return `/standings`
  }

  if (name === 'predictions') {
    return `/predictions`
  }

  if (name === 'injury-report') {
    return `/injury-report`
  }

  if (name === 'transactions') {
    return `/transactions`
  }
  if (name === 'league-contracts') {
    return `/league-contracts`
  }

  if (name === 'bet') {
    return `/bet`
  }

  if (name === 'draft-central') {
    return `/draft-central`
  }
  if (name === 'all-star') {
    return `/all-star`
  }

  if (name === 'playoffs') {
    return `/playoffs`
  }

  if (name === 'questions') {
    return `/questions`
  }

  if (name === 'homepage' || name === '') {
    return `/`
  }
  throw new Error(`Unknown target ${name}`)
}

/**
 *
 * Create UTM Link
 */

type ShopParams = {
  medium: string
  slug?: string
  campaign: string
  isFullLink?: boolean
}
export const createShopUTM = ({
  medium,
  campaign,
  slug,
  isFullLink = false,
}: ShopParams) => {
  //Just add the utms if isFullLink is true
  return isFullLink
    ? `${slug}?utm_source=Web_Main&utm_medium=${medium}&utm_campaign=${campaign}`
    : `${PLL_LINKS.shop}/${
        slug && slug
      }?utm_source=Web_Main&utm_medium=${medium}&utm_campaign=${campaign}`
}

export const createPlayerShopUTM = ({ medium, campaign, slug }: ShopParams) => {
  return `${slug}?utm_source=Web_Main&utm_medium=${medium}&utm_campaign=${campaign}`
}

type TicketParams = {
  ticketId: string
}
export const createTicketUTM = ({ ticketId }: TicketParams) => {
  if(ticketId.includes('http') && !ticketId.includes('ticketmaster')) {
    return ticketId
  }
  if (!ticketId.includes('.com')) {
    return `${TICKETMASTER_BASE_URL}/event/${ticketId}?${TICKETMASTER_CAME_FROM}`
  }
  if (ticketId.includes('ticketmaster')) return `${ticketId}?${TICKETMASTER_CAME_FROM}`
  return ticketId
}
